/**
 * Canonical Work Order Task state-code → DaisyUI badge colour, shared by the ticket overview
 * list and the detail page so a given state always renders the same colour in both. WOT state
 * codes per the SmartTeams spec (Work Order Task System Integration §5.2). Cancelled (7) is
 * filtered out of the overview list server-side, but the colour stays defined so direct-link /
 * detail visits still render a sensible badge.
 */
export const STATE_BADGE_CLASS: Record<string, string> = {
  '1': 'badge-neutral', // Draft
  '3': 'badge-success', // Closed Complete
  '4': 'badge-warning', // Closed Incomplete
  '7': 'badge-error', // Cancelled
  '10': 'badge-info', // Pending Dispatch
  '12': 'badge-warning', // Scheduled
  '16': 'badge-primary', // Assigned
  '17': 'badge-accent', // Accepted
  '18': 'badge-success', // Work in Progress
  '19': 'badge-success', // Resolved (intervention finished; awaiting close)
};
